module.exports = __webpack_public_path__ + "img/loginbg.cdb27180.jpg";